"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyPageContentTemplate = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const CircleBackgroundAnimation_1 = require("../../context/CircleBackgroundAnimation");
/**
 * Template represents a layout for content on main pages of the survey.
 * On mobile devices there is only content block.
 * On desktop devices you'll see also an image in the left column.
 *
 * @param image - displaying image in the left column
 * @param content - content of the page in the right column
 * @param alternate - if true, image and content will be displayed in reverse order
 * @constructor
 */
function SurveyPageContentTemplate({ Image, content, alternate, className, }) {
    const imageRef = (0, react_1.useRef)(null);
    const [, dispatch] = (0, CircleBackgroundAnimation_1.useCircleBackgroundAnimation)();
    (0, react_1.useLayoutEffect)(() => {
        const resize = () => {
            if (!imageRef.current) {
                return;
            }
            const { height, width, left } = imageRef.current.getBoundingClientRect();
            dispatch((0, CircleBackgroundAnimation_1.setImageWidth)(width));
            dispatch((0, CircleBackgroundAnimation_1.setImageHeight)(height));
            dispatch((0, CircleBackgroundAnimation_1.setImageLeft)(left - 80));
        };
        window.addEventListener('resize', resize);
        resize(); // Make first call on render
        return () => window.removeEventListener('resize', resize);
        // eslint-disable-next-line react-hooks/exhaustive-deps -- dispatch method won't change
    }, []);
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { "$alternate": alternate, className: className, "data-e2e": 'SurveyPageContentTemplate_Wrapper', children: [(0, jsx_runtime_1.jsx)(Image, { ref: imageRef, "data-e2e": 'SurveyPageContentTemplate_Image' }), (0, jsx_runtime_1.jsx)(ContentContainer, { "data-e2e": 'SurveyPageContentTemplate_ContentContainer', children: content })] }));
}
exports.SurveyPageContentTemplate = SurveyPageContentTemplate;
const Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  height: 100%;

  // Don't show image on mobile devices
  & > svg {
    display: none;
  }

  ${ui_1.device.tablet `
    justify-content: center;

    gap: 40px;

    // Show image only on desktop devices
    & > svg {
      display: block;

      width: auto;
      height: 100%;

      // Fix for fill color in SVG
      color: #000;

      z-index: 1;
    }
  `};

  ${({ $alternate }) => ui_1.device.tablet((0, styled_components_1.css) `
      flex-direction: ${$alternate ? 'row-reverse' : 'row'};
    `)}
`;
const ContentContainer = styled_components_1.default.div `
  height: 100%;
  width: 100%;

  display: flex;
  align-items: center;
  flex-shrink: 0;
  flex-direction: column;

  box-sizing: border-box;

  ${ui_1.device.tablet `
    height: 100%;
    width: 376px;
    
    align-items: flex-start;
    
    padding: 0 16px 16px;
  `};
`;
